import React from 'react';
import PropTypes from 'prop-types';

import {useLocation} from 'react-router-dom';

import {dispatch, connect} from 'utils/state_manager';

import {Box} from 'views/components';

import NavbarService from './NavbarService';

const NavbarServices = (props) => {
  const services = props.services;

  const location = useLocation();

  return (
    <Box
    >
      {
        services.map((e, index) => {
          return (
            <Box
              key={index}
              sx={{
                mb: 1,
                ml: 3,
              }}
            >
              <NavbarService
                selected={e.isActive(location.pathname)}
                title={e.title}
                link={e.link}
                options={Object.values(e.options)}
              />
            </Box>
          );
        })
      }
    </Box>
  );
};
NavbarServices.propTypes = {
  services: PropTypes.array.isRequired,
};
const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NavbarServices));
